import React from 'react';
import { Navigate } from 'react-router';
import Base from './Base';
import { Header } from './Header';
import { Footer } from './Footer';
import SelectAsync from 'react-select/async';

export default class TimeSheetHeader extends Base {
    constructor(props) {
        super(props);
        this.state = {
            refreshCallerAfterSave: this.isNull(props.RefreshCallerAfterSave) ? true : props.RefreshCallerAfterSave,
            caller: props.Caller,
            id: props.Id,
            data: null,
            loading: true,
            initType: this.isNull(props.InitType) ? 0 : props.InitType,
            orderingId: this.isNull(props.OrderingId) ? this.getDefaultGuid() : props.OrderingId,
            id: this.isNull(props.Id) ? this.defaultGuid() : props.Id,
        };
        this.keyDownFunction = this.keyDownFunction.bind(this);
    }
    componentWillUnmount() {
        this.removeKeyDown();
    }
    componentDidMount() {
        this.addKeyDown();
        this.httpPost("api/v1/timesheetheader/get", {
            id: this.state.id,
            orderingId: this.state.orderingId,
            initType: this.state.initType,
        })
            .then(data => {
                if (data.status === -1) window.location.href = "/login";
                if (data.status === 1) {
                    this.setState({
                        data: data,
                        loading: false
                    })
                }
                else {
                    this.showErorrMessage(data.message);
                    this.setState({
                        loading: false
                    });
                }
            });
    }
    save(e) {
        e.preventDefault();
        if (this.isBlank(this.state.data.record.year)) this.state.data.record.year = 0;
        if (this.isBlank(this.state.data.record.month)) this.state.data.record.month = 0;
        this.httpPost("api/v1/timesheetheader/save", {
            id: this.getCurrentFormId(),
            companyId: this.state.data.global.company.id,
            contractId: this.state.data.record.contractId,
            projectId: this.state.data.record.projectId,
            crmTeamId: this.state.data.record.crmTeamId,
            orderingId: this.state.data.record.orderingId,      
            type: this.state.data.record.type,
            nobat: this.state.data.record.nobat,
            year: parseInt(this.state.data.record.year),
            month: parseInt(this.state.data.record.month),
            employeeWorkStationGroupId: this.state.data.record.employeeWorkStationGroupId,
            employeeWorkStationId: this.state.data.record.employeeWorkStationId,
            note: this.state.data.record.note,
        })
            .then(data => {
                if (data.status === -1) window.location.href = "/login";
                if (data.status === 1) {
                    this.showSuccessMessage("اطلاعات با موفقیت ذخیره شد");
                    if (this.state.refreshCallerAfterSave)
                        this.state.caller.refreshData();
                    this.closeMe();
                }
                else {
                    this.showErorrMessage(data.message);
                    this.setState({
                        loading: false
                    });
                }
            });
    }
    setProject(e) {
        this.state.data.record.projectId = e.value;
        this.state.data.record.projectName = e.label;
    }
    setOrdering(e) {
        this.state.data.record.orderingId = e.value;
        this.state.data.record.orderingTitle = e.label;
    }
    setType(e) {
        this.state.data.record.type = e;
        this.setState({ data: this.state.data });
    }
    renderForm() {
        return <div className="modal fade listModal in show" tabIndex="-1" role="dialog">
            <div className="modal-backdrop fade in" style={{ "height": "100%" }} onClick={e => this.closeMe()}></div>
            <div className="modal-dialog ui-draggable" style={{ "width": "96%", "left": "7.125px", "top": "-2px" }}>
                <div className="modal-content">
                    <div className="modal-body">
                        <div className="modal-header modal-header-info" style={{ "padding": "0" }}>
                            <button type="button" className="close" onClick={e => this.closeMe()} aria-label="Close"><span aria-hidden="true">×</span></button>
                            <h4 className="modal-title">{this.getCaption()}</h4>
                        </div>
                        <div className="modal-body" style={{ "display": "flex", "flex-direction": "column", "gap": "10px" }}>
                            <div className="row">
                                {this.state.initType == 0 && this.state.data.record.id === this.getDefaultGuid() && <div className="col-lg-4">
                                    <div className="form-group">
                                        <label className="form-label">نوع تایم شیت</label>
                                        <div className="form-control-wrap">
                                            <select defaultValue={this.state.data.record.type} className="form-control" onChange={e => this.setType(parseInt(e.target.value))}>
                                                <option value="1">عملکرد کارکنان بر اساس قرارداد کار</option>
                                                <option value="2">عملکرد نفرات بر روی پروژه</option>
                                                <option value="3">عملکرد نفرات بر روی تیم های Crm</option>
                                                <option value="4">عملکرد نفرات روی سفارش تولید</option>
                                            </select>
                                        </div>
                                    </div>
                                </div>}
                                {this.state.data.record.type === 2 && <div className="col-lg-12">
                                    <div className="form-group">
                                        <label className="form-label">پروژه</label>
                                        <div className="form-control-wrap">
                                            <SelectAsync
                                                style={{ "width": "100%" }}
                                                defaultValue={this.state.data.record.projectId !== this.getDefaultGuid() ? [{ value: this.state.data.record.projectId, label: this.state.data.record.projectName }] : null}
                                                isMulti={false}
                                                placeholder="انتخاب پروژه"
                                                defaultOptions
                                                loadOptions={(inputValue, callback) => this.loadSolutionsOptions(inputValue, callback, 0)}
                                                onChange={e => this.setProject(e)}
                                            />
                                        </div>
                                    </div>
                                </div>}
                                {this.state.data.record.type === 1 && <div className="col-lg-12">
                                    <div className="form-group">
                                        <label className="form-label">قرارداد</label>
                                        <div className="form-control-wrap">
                                            <select defaultValue={this.state.data.record.contractId} className="form-control" onChange={e => this.state.data.record.contractId = e.target.value}>
                                                <option value={this.defaultGuid()}>لطفا یکی از قراردادها را انتخاب نمایید</option>
                                                {this.state.data.contracts.map(record => <option value={record.id}>قرارداد شماره {record.number} {record.manCompanyName} و موضوع {record.subject}</option>)}
                                            </select>
                                        </div>
                                    </div>
                                </div>}
                                {this.state.data.record.type === 3 && <div className="col-lg-12">
                                    <div className="form-group">
                                        <label className="form-label">تیم Crm</label>
                                        <div className="form-control-wrap">
                                            <select defaultValue={this.state.data.record.crmTeamId} className="form-control" onChange={e => this.state.data.record.crmTeamId = e.target.value}>
                                                <option value={this.defaultGuid()}>لطفا یکی از تیم های Crm را انتخاب نمایید</option>
                                                {this.state.data.crmTeams.map(record => <option value={record.id}>{record.title}</option>)}
                                            </select>
                                        </div>
                                    </div>
                                </div>}
                                {this.state.initType == 0 && this.state.data.record.type === 4 && <div className="col-lg-12">
                                    <div className="form-group">
                                        <label className="form-label">سفارش در حال تولید</label>
                                        <div className="form-control-wrap">
                                            <SelectAsync
                                                style={{ "width": "100%" }}
                                                defaultValue={this.state.data.record.orderingId !== this.getDefaultGuid() ? [{ value: this.state.data.record.orderingId, label: this.state.data.record.orderingTitle }] : null}
                                                isMulti={false}
                                                placeholder="انتخاب سفارش"
                                                defaultOptions
                                                loadOptions={(inputValue, callback) => this.loadOrderingsOptions(inputValue, callback, 6)}
                                                onChange={e => this.setOrdering(e)}
                                            />
                                        </div>
                                    </div>
                                </div>}
                                {this.state.data.record.type === 1 && <div className="col-lg-6">
                                    <div className="form-group">
                                        <label className="form-label">ایستگاه کاری</label>
                                        <div className="form-control-wrap">
                                            <select defaultValue={this.state.data.record.employeeWorkStationId} className="form-control" onChange={e => this.state.data.record.employeeWorkStationId = e.target.value}>
                                                <option value={this.getDefaultGuid()}>لطفا یکی از ایستگاهها را انتخاب نمایید</option>
                                                {this.state.data.stations.map(record => <option value={record.id}>{record.title}</option>)}
                                            </select>
                                        </div>
                                    </div>
                                </div>}
                                {this.state.data.record.type === 1 && <div className="col-lg-6">
                                    <div className="form-group">
                                        <label className="form-label">گروه کاری</label>
                                        <div className="form-control-wrap">
                                            <select defaultValue={this.state.data.record.employeeWorkStationGroupId} className="form-control" onChange={e => this.state.data.record.employeeWorkStationGroupId = e.target.value}>
                                                <option value={this.getDefaultGuid()}>لطفا یکی از گروه ها را انتخاب نمایید</option>
                                                {this.state.data.stationGroups.map(record => <option value={record.id}>{record.title}</option>)}
                                            </select>
                                        </div>
                                    </div>
                                </div>}
                                {this.state.data.record.type === 1 && <div className="col-lg-4">
                                    <div className="form-group">
                                        <label className="form-label">وضعیت کارکرد</label>
                                        <div className="form-control-wrap">
                                            <select className="form-control" type="text" defaultValue={this.state.data.record.nobat} onChange={e => this.state.data.record.nobat = parseInt(e.target.value)}>
                                                <option value='1'>ساعت عادی -صبح و عصر</option>
                                                <option value='2'>ساعت عادی -پارتایم</option>
                                                <option value='3'>نوبت کار -صبح و عصر</option>
                                                <option value='4'>نوبت کار -صبح عصر شب</option>
                                                <option value='5'>نوبت کار - صبح شب</option>
                                                <option value='6'>نوبت کار -شب عصر</option>
                                            </select>
                                        </div>
                                    </div>
                                </div>}
                                <div className="col-lg-2">
                                    <div className="form-group">
                                        <label className="form-label">سال</label>
                                        <div className="form-control-wrap">
                                            <input maxLength="4" className="form-control" type="text" defaultValue={this.state.data.record.year} onChange={e => this.state.data.record.year = e.target.value} />
                                        </div>
                                    </div>
                                </div>
                                <div className="col-lg-2">
                                    <div className="form-group">
                                        <label className="form-label">ماه</label>
                                        <div className="form-control-wrap">
                                            <select className="form-control" type="text" defaultValue={this.state.data.record.month} onChange={e => this.state.data.record.month = parseInt(e.target.value)}>
                                                <option value='1'>فروردین</option>
                                                <option value='2'>اردیبهشت</option>
                                                <option value='3'>خرداد</option>
                                                <option value='4'>تیر</option>
                                                <option value='5'>مرداد</option>
                                                <option value='6'>شهریور</option>
                                                <option value='7'>مهر</option>
                                                <option value='8'>آبان</option>
                                                <option value='9'>آذر</option>
                                                <option value='10'>دی</option>
                                                <option value='11'>بهمن</option>
                                                <option value='12'>اسفند</option>
                                            </select>
                                        </div>
                                    </div>
                                </div>
                                <div className="col-lg-12">
                                    <div className="form-group">
                                        <label className="form-label">یادداشت داخلی</label>
                                        <div className="form-control-wrap">
                                            <input maxLength="400" className="form-control" type="text" defaultValue={this.state.data.record.note} onChange={e => this.state.data.record.note = e.target.value} />
                                        </div>
                                    </div>
                                </div>
                                <div className="col-lg-12">
                                    <div className="form-group">
                                        <button type="submit" className="btn btn-lg btn-primary">ذخیره</button>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className="modal-footer">
                            <button type="button" className="hand btn btn-primary" onClick={e => this.save(e)}>ذخیره</button>                            
                            <a className="btn btn-warning" onClick={e => this.closeMe()}>انصراف</a>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    }
    render() {
        if (!this.isBlank(this.state.redirect)) return <Navigate to={this.state.redirect} />

        let contents = this.state.loading ? this.renderLoading() :
            [
                this.state.lockScreen === 1 && this.lockScreen(),
                <Header data={this.state.data} />,
                <div className="nk-content ">
                    <div className="container-fluid">
                        <div className="nk-content-inner">
                            {this.renderForm()}
                        </div>
                    </div>
                </div>,
                <Footer />
            ];

        return contents;
    }
}